<template>
  <div>
    <div class="row">
      <div
      v-if="!loggedInUserData.is_staff"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          style="height: auto; padding-left: 0px; padding-right: 0px"
          to="/make-new-order"
          depressed
        >
          <i
              style="font-size: 23px;"
              class="material-icons" :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'"
            >add_box</i>&nbsp;
          New Order
        </v-btn>
      </div>
      <div
        v-if="addExportButton || addPrepareToPrintButton"
        class="col-sm-4 col-md-2 text-left"
      >
        <v-btn
          style="height: auto; padding-left: 0px; padding-right: 0px"
          @click="
            resetGetResults()
            filterApplied = false
            startTime.time = ''
            startTime1.time = ''
            ware = 'Select'
          "
          depressed
        >
          <v-icon
            icon
            :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'"
          >cached</v-icon>&nbsp; Reload Table
        </v-btn>
      </div>
      <div
        v-else
        class="text-left" :class="!loggedInUserData.is_staff ? 'col-sm-4 col-md-3' : 'col-sm-6 col-md-6'"
        style="padding-top: 4px"
      >
        <v-btn
          style="height: auto"
          @click="
            resetGetResults()
            filterApplied = false
            startTime.time = ''
            startTime1.time = ''
            ware = 'Select'
          "
          depressed
        >
          <v-icon
            icon
            :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'"
          >cached</v-icon>&nbsp; Reload Table
        </v-btn>
      </div>

      <div
        v-if="addExportButton"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          style="height: auto; padding-left: 0px; padding-right: 0px"
          @click="sendToExport"
          depressed
        >
          <v-icon :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'">explicit</v-icon>&nbsp; Export
        </v-btn>
      </div>

      <div
        v-if="addPrepareToPrintButton"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="prepareToPrint()"
          style="height: auto; padding-left: 0px; padding-right: 0px"
          depressed
        >
          <v-icon style="color: #006b8d">print</v-icon> &nbsp; Prepare to print
        </v-btn>
      </div>

      <div
        v-if="!removeAddButton"
        class="col-sm-6 col-md-6 text-right mobile"
      >
        <v-btn
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp;Add
          New
        </v-btn>
      </div>
      <div
        v-if="showAddExportOrderButton"
        class="col-sm-6 col-md-6 text-right mobile"
      >
        <v-btn
          style="height: auto"
          depressed
          @click="handleAddExportOrder"
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg mr-2"
          > </v-icon>
          Add New
        </v-btn>
      </div>
      <div
        v-if="addQrCodeGenerateButton && $_has_perm(permissions.generate_qr_code)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openGenerateQrCodeModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-qrcode fa-2x"
            aria-hidden="true"
          ></i> &nbsp;Generate QrCode</v-btn>
      </div>
      <div
        v-if="addOrderInvoiceButton && $_has_perm(permissions.add_shipping_invoice)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openOrderInvoiceModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-file-text-o mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;Generate Invoice</v-btn>
      </div>
      <div
        v-if="addSecondOrderInvoiceButton && $_has_perm(permissions.add_second_shipping_invoice)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSecondOrderInvoiceModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-file-text-o mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;Generate 2nd Invoice</v-btn>
      </div>
      <div
        v-if="addDeliveryInvoiceButton && $_has_perm(permissions.add_delivery_invoice)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openDeliveryInvoiceModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-motorcycle mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;Delivery Invoice</v-btn>
      </div>
      <div
        v-if="!removeWarehouseDeliverButton && $_has_perm(permissions.send_to_warehouse)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openSendToWarehouseModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send to warehouse</v-btn>
      </div>
      <div
        v-if="addSendToIntShipmentButton && $_has_perm(permissions.send_to_shipment)"
        class="col-sm-6 col-md-2 text-right"
      >
        <v-btn
          @click="openSendToIntShipmentModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send to Shipment</v-btn>
      </div>
      <div
        v-if="addSendAllToIntShipmentButton && $_has_perm(permissions.send_to_shipment)"
        class="col-sm-6 col-md-2 text-right"
      >
        <v-btn
          @click="sendAllToIntShipment()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send all to Shipment</v-btn>
      </div>
      <div
        v-if="addSendToPendingToBranchButton && $_has_perm(permissions.deliver_to_pending_to_branch)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToPendingToBranchModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send to Pending To Branch</v-btn>
      </div>
      <div
        v-if="addSendToBranchButton && $_has_perm(permissions.deliver_to_branch)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToBranchModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send to Branch</v-btn>
      </div>
      <div
        v-if="addSendAllToBranchButton && $_has_perm(permissions.deliver_to_branch)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="sendAllToPendingToBranch()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send All To Branch</v-btn>
      </div>
      <div
        v-if="addSendToUserButton && $_has_perm(permissions.send_to_customer)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToUserModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send to Customer</v-btn>
      </div>

      <div
        v-if="addSendAllToUserButton && $_has_perm(permissions.send_to_customer)"
        class="col-sm-6 col-md-3"
      >
        <v-btn
          @click="sendAllToUser()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;Send All To Customer</v-btn>
      </div>
      <div
        v-if="addInsertStaffButton && $_has_perm(permissions.add_staff)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddStaffModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >person_add</i> &nbsp; Add Staff</v-btn>
      </div>
      <div
        v-if="addNewOrderButton && $_has_perm(permissions.add_permission)"
        class="text-right mobile"
        :class="(addSendToIntShipmentButton || addSendAllToIntShipmentButton) && $_has_perm(permissions.send_to_shipment) ? 'col-sm-2 col-md-12' : 'col-sm-3 col-md-6'"
      >
        <v-btn
          @click="openAddNewOrderModal(), (checkAlert = false)"
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp; New Order
        </v-btn>
      </div>
      <div
        v-if="cashBackButton && $_has_perm(permissions.add_cashback)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openCashBackModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          > monetization_on</i> &nbsp; Cash
          Back</v-btn>
      </div>
      <div
        v-if="addCreatCreditButton && $_has_perm(permissions.add_credit)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openCreatCreditModal()"
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp; Add
          Credit
        </v-btn>
      </div>
      <div
        v-if="addWarehouseButton && $_has_perm(permissions.add_warehouse)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openAddWarehouseModal()"
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp; Add
          Warehouse
        </v-btn>
      </div>
      <div
        v-if="showCreateCustomerButton && $_has_perm(permissions.add_customer)"
        class="col-sm-6 col-md-6 col-lg-3 text-right mobile"
      >
        <v-btn
          @click="openCreateCustomerModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >person_add</i> &nbsp; ADD
          Customer</v-btn>
      </div>
      <div
        v-if="addGenerateCouponButton && $_has_perm(permissions.add_coupon)"
        class="col-sm-6 col-md-6 text-left"
      >
        <v-btn
          @click="openGenerateCouponModal()"
          style="height: auto"
          depressed
        >
          <!-- <i class="fa fa-credit-card-alt"></i> &nbsp; -->
          Generate Coupon
        </v-btn>
      </div>
      <div
        v-if="addBankButton && $_has_perm(permissions.add_bank)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddBankModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add Bank</v-btn>
      </div>
      <div
        v-if="addSupplierButton"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddSupplierModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add Supplier</v-btn>
      </div>
      <div
        v-if="addExpenseTypeButton && $_has_perm(permissions.add_expense_type)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddExpenseTypeModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add Expense Type</v-btn>
      </div>
      <div
        v-if="addExpenseButton && $_has_perm(permissions.add_expense)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddExpenseModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New Expense</v-btn>
      </div>

      <div
        v-if="addNotFoundOrderButton && $_has_perm(permissions.add_not_found_order)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddNotFoundOrderModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New</v-btn>
      </div>

      <div
        v-if="addCityButton && $_has_perm(permissions.add_city)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddCityModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New City</v-btn>
      </div>

      <div
        v-if="addReasonButton && $_has_perm(permissions.add_reason)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddReasonModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New Reason</v-btn>
      </div>

      <div
        v-if="addAboutButton && $_has_perm(permissions.add_about)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddAboutModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New About App</v-btn>
      </div>

      <div
        v-if="addCurrencyRateButton && $_has_perm(permissions.add_currency_rate)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddCurrencyRateModal()"
          style="height: auto"
          depressed
        >
          <i
            class="material-icons"
            style="color: #006b8d"
          >
            add
          </i>
          &nbsp; Add New</v-btn>
      </div>

      <div
        v-if="addNewExportOrderButton && $_has_perm(permissions.add_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddNewExportOrderModal()"
          style="height: auto"
          depressed
        >
          <i
            class="material-icons"
            style="color: #006b8d"
          >
            add
          </i>
          &nbsp; Add New</v-btn>
      </div>

      <div
        v-if="addRoleButton && $_has_perm(permissions.add_role)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddRoleModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New Role</v-btn>
      </div>

      <div
        v-if="addBranchButton && $_has_perm(permissions.add_branch)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddBranchModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add New Branch</v-btn>
      </div>

      <div
        v-if="addMoneyButton && $_has_perm(permissions.add_money)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddMoneyModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add Money</v-btn>
      </div>
      <div
        v-if="addMoneyTransferButton && $_has_perm(permissions.add_money_transfer)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddMoneyTransferModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Transfer Money</v-btn>
      </div>
      <div
        v-if="showPurchaseAll && $_has_perm(permissions.purchase_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="confirmPurchaseAll()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add_shopping_cart</i> &nbsp;
          Purchase</v-btn>
      </div>
      <div
        v-if="showApproveAll && $_has_perm(permissions.approve_all_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="approvingMultipleOrder()"
          :loading="loadApproveAll"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >check_circle</i> &nbsp; Approve</v-btn>
      </div>
      <div
        v-if="addExchangeRateButton && $_has_perm(permissions.add_exchange_rate)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddExchangeRateModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; Add Exchange Rate</v-btn>
      </div>
    </div>

    <v-layout
      wrap
      class="mx-2"
    >
      <v-flex
        xs12
        sm12
        md3
      >
        <v-text-field
          append-icon="search"
          :append-icon-cb="() => searchMe(tableData.search)"
          id="search-field"
          label="Search"
          hide-details
          v-model="tableData.search"
          @keyup.enter="searchMe(tableData.search)"
        >
        </v-text-field>
      </v-flex>

      <v-flex
        sm12
        md5
        lg6
        style="padding-top: 10px; padding-left: 20px"
      >
        <v-layout wrap>
          <v-flex
            v-if="addSelect"
            xs12
            sm12
            md3
            style="padding-top: 10px"
          >
            <v-select
              :items="dates"
              v-model="dateValue"
              @input="prepareToExport()"
              label="Select"
              single-line
              hide-details
            ></v-select>
          </v-flex>
          <v-flex
            v-else
            xs2
            sm1
            md1
            style="padding-top: 25px; margin-right: 10px"
          >
            <p>Filter:</p>
          </v-flex>

          <v-flex
            xs4
            sm4
            md3
            class="px-2"
          >
            <date-picker
              style="margin-top: 2px; border-bottom-color: #919191"
              :date="startTime"
              :option="option"
              class="form-control"
            ></date-picker>
          </v-flex>

          <v-flex
            xs4
            sm4
            md3
            class="px-2"
          >
            <date-picker
              style="margin-top: 2px; border-bottom-color: #919191"
              :date="startTime1"
              :option="option1"
              class="form-control"
            ></date-picker>
          </v-flex>

          <v-flex
            xs1
            sm1
            md1
            class="px-2"
            style="padding-top: 17px"
          >
            <a
              v-if="!filterApplied"
              tooltip="Apply Filter"
              @click="checkDates()"
            ><i class="fa fa-filter fa-2x"></i></a>

            <a
              v-if="filterApplied"
              tooltip="Cancel Filter"
              @click="
                  resetGetResults2()
                  filterApplied = false
                  startTime.time = ''
                  startTime1.time = ''
                "
              style="color: orange"
            >
              <span class="fa-stack">
                <i class="fa fa-filter fa-stack-2x"></i>
                <i
                  class="fa fa-times fa-stack-1x"
                  style="padding-left: 14px; padding-top: 7px"
                ></i>
              </span>
            </a>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        sm12
        md4
        lg3
        v-if="!intShipment"
        class="px-2"
        style="padding-top: 25px"
      >
        <v-layout wrap>
          <v-flex
            sm8
            md6
            lg8
            xl6
            class="px-2"
          >
            <label
              v-if="!filterMade"
              style="padding-top: 10px"
            >
              Show
              <span v-show="pagination.from && pagination.to">{{ pagination.from || 0 }}-{{ pagination.to }} of {{ pagination.total }} </span>Result
            </label>
            <label
              v-else
              style="padding-top: 10px; float: right; font-size: 14px"
            >Total Result {{ totalResult }}</label>
          </v-flex>

          <v-flex
            sm1
            md1
            v-if="!filterMade"
          >
            <v-select
              :items="options"
              item-value="value"
              v-model="val"
              @input="getPerPage()"
              label="Select"
              single-line
              hide-details
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        v-else
        sm12
        md4
        style="padding-top: 30px"
      >
        <v-layout wrap>
          <v-flex
            sm5
            md5
          >
            <label
              v-if="!filterMade"
              style="padding-top: 10px; float: right; font-size: 14px"
            >
              Show
              <span v-show="pagination.from && pagination.to">{{ pagination.from || 0 }} - {{ pagination.to }} of
                {{ pagination.total }}
              </span>
              &nbsp;&nbsp;
            </label>
            <label
              v-else
              style="padding-top: 10px; float: right; font-size: 14px"
            >Total Result {{ totalResult }}</label>
          </v-flex>

          <v-flex
            sm2
            md2
            v-if="!filterMade"
          >
            <v-select
              :items="options"
              v-model="val"
              @input="getPerPage()"
              label="Select"
              single-line
              hide-details
            ></v-select>
          </v-flex>

          <v-flex
            sm1
            md1
            v-if="!filterMade"
          >
            <v-select
              :items="warehouses"
              v-model="ware"
              @input="prepareGetByWarehouse()"
              label="Select"
              single-line
              hide-details
              :hint="wareError === true ? 'Please select warehouse' : ''"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <!-- <v-flex
        v-if="loggedInUserData.is_staff && !hideBranch"
        sm12
        md6
        lg5
        xl4
        class="px-3"
      >
        <div class="row">
          <div class="col-sm-10">
            <v-select
              :items="branchesList"
              v-model="branches"
              multiple
              autocomplete
              hide-details
              chips
              deletable-chips
              label="Branch"
              clearable
            >
            </v-select>
          </div>
          <div class="col-sm-2 pt-4">
            <button
              class="py-1 px-3 white--text filter-branch-btn"
              :class="branches.length > 0 ? 'pointer primary' : 'grey lighten-1 not-allowed'"
              style="border-radius: 4px"
              :disabled="branches.length == 0"
              @click="filterBranch(branches)"
            >
              Done
            </button>
          </div>
        </div>
      </v-flex> -->

      <v-flex
        v-if="!hideSelectingColumn"
        sm12
        md7
        lg7
        xl8
        class="px-3"
      >
        <v-select
          :items="columns"
          v-model="colVal"
          @input="prepareToShowHideColumn(colVal)"
          multiple
          hide-details
          chips
          deletable-chips
          label="Show/Hide Columns"
        ></v-select>
      </v-flex>

      <slot name="custom-filter" />
    </v-layout>
  </div>
</template>

<script>
import myDatepicker from 'vue-datepicker'
import swal from 'sweetalert'
import Axios from 'axios'

export default {
  created() {
    this.getLoggedInUser()
    this.getConnectedBranches()
    this.setDefaultPerPage()
  },

  components: {
    'date-picker': myDatepicker
  },

  props: [
    'permissions',
    'showApproveAll',
    'loadApproveAll',
    'approvingMultipleOrder',
    'showPurchaseAll',
    'confirmPurchaseAll',
    'filterMade',
    'totalResult',
    'hideSelectingColumn',
    'showHideColumn',
    'columns',
    'getDependDate',
    'addSelect',
    'addBankButton',
    'openAddBankModal',
    'addPrepareToPrintButton',
    'prepareToPrint',
    'removeWarehouseDeliverButton',
    'tableData',
    'resetGetResults',
    'resetGetResults2',
    'searchMe',
    'pagination',
    'removeAddButton',
    'perPageFix',
    'filterTable',
    'openSendToWarehouseModal',
    'addInsertStaffButton',
    'openAddStaffModal',
    'openAddWarehouseModal',
    'openAddNewOrderModal',
    'addNewOrderButton',
    'checkAlert',
    'showCreateCustomerButton',
    'openCreateCustomerModal',
    'addCreatCreditButton',
    'addSecondOrderInvoiceButton',
    'openSecondOrderInvoiceModal',
    'openCreatCreditModal',
    'addQrCodeGenerateButton',
    'showAddExportOrderButton',
    'handleAddExportOrder',
    'openGenerateQrCodeModal',
    'addSendToIntShipmentButton',
    'openSendToIntShipmentModal',
    'addSendAllToIntShipmentButton',
    'sendAllToIntShipment',
    'addSendToBranchButton',
    'addSendToPendingToBranchButton',
    'openSendToBranchModal',
    'addSendToUserButton',
    'openSendToUserModal',
    'addExportButton',
    'addWarehouseButton',
    'sendToExport',
    'addGenerateCouponButton',
    'openGenerateCouponModal',
    'cashBackButton',
    'openCashBackModal',
    'intShipment',
    'getByWarehouse',
    'addExchangeRateButton',
    'openAddExchangeRateModal',
    'addSupplierButton',
    'openAddSupplierModal',
    'addOrderInvoiceButton',
    'openOrderInvoiceModal',
    'addSendAllToUserButton',
    'sendAllToUser',
    'addExpenseTypeButton',
    'openAddExpenseTypeModal',
    'addExpenseButton',
    'openAddExpenseModal',
    'addRoleButton',
    'openAddRoleModal',
    'addBranchButton',
    'openAddBranchModal',
    'addMoneyTransferButton',
    'openAddMoneyTransferModal',
    'addMoneyButton',
    'openAddMoneyModal',
    'hideBranch',
    'addDeliveryInvoiceButton',
    'openDeliveryInvoiceModal',
    'openSendToPendingToBranchModal',
    'addSendAllToBranchButton',
    'sendAllToPendingToBranch',
    'addCityButton',
    'addReasonButton',
    'addAboutButton',
    'openAddAboutModal',
    'openAddCityModal',
    'openAddReasonModal',
    'addNotFoundOrderButton',
    'openAddNotFoundOrderModal',
    'addCurrencyRateButton',
    'openAddCurrencyRateModal',
    'addNewExportOrderButton',
    'openAddNewExportOrderModal'
  ],

  data() {
    return {
      colVal: [],
      prevColVal: [],
      branchesList: [],
      branches: [],
      loggedInUserData: {},
      options: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: '150', value: 150 },
        { text: '200', value: 200 },
        { text: '250', value: 250 },
        { text: '300', value: 300 },
        { text: '350', value: 350 },
        { text: '400', value: 400 },
        { text: '450', value: 450 },
        { text: '500', value: 500 }
      ],
      warehouses: [
        { text: 'Select', value: 'Select' },
        { text: 'USA', value: 1 },
        // { text: 'Turkey', value: 2 },
        { text: 'China', value: 3 },
        { text: 'UAE', value: 4 }
      ],
      dates: [
        { text: 'Choose', value: '' },
        { text: 'Order', value: 'orders.created_at' },
        { text: 'Confirm', value: 'orders.confirm_date' },
        { text: 'Purchase', value: 'orders.purchase_date' }
      ],
      val: 50,
      dateValue: '',
      ware: 'Select',
      filterApplied: false,
      wareError: false,
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      limit: [
        {
          type: 'weekday',
          available: [1, 2, 3, 4, 5]
        },
        {
          type: 'fromto',
          from: '2016-02-01',
          to: '2016-02-20'
        }
      ]
    }
  },

  watch: {
    colVal(newVal, oldVal) {
      this.prevColVal = oldVal
    },

    branches(newVal) {
      if (newVal.length === 0) {
        this.$emit('branch-edit', newVal)
      }
    }
  },

  methods: {
    setDefaultPerPage() {
      if (this.loggedInUserData && !this.loggedInUserData.is_staff) {
        this.val = 50
      } else {
        this.val = 10
      }
      // Update tableData to match
      if (this.tableData) {
        this.tableData.per_page = this.val
      }
    },

    filterBranch(branches) {
      let filterBtn = document.querySelector('.filter-branch-btn')
      filterBtn.classList.add('animate-filter-branch-btn')
      this.$emit('branch-edit', branches)
      setTimeout(() => {
        filterBtn.classList.remove('animate-filter-branch-btn')
      }, 400)
    },

    prepareToShowHideColumn(currentColVal) {
      setTimeout(() => {
        this.showHideColumn(this.prevColVal, currentColVal)
      }, 500)
    },

    prepareToExport() {
      if (this.dateValue === '') {
        this.dateValue = 'orders.created_at'
      } else {
        this.getDependDate(this.dateValue)
      }
    },

    getPerPage() {
      this.tableData.per_page = this.val
      this.perPageFix(this.tableData.per_page)
    },

    prepareGetByWarehouse() {
      if (this.ware === 'Select') {
        this.wareError = true
      } else {
        this.wareError = false
        this.tableData.warehouse = this.ware
        this.getByWarehouse(this.tableData.warehouse)
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getConnectedBranches() {
      this.branchesList = []
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data
          result.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    checkDates() {
      if (this.startTime.time === '' || this.startTime1.time === '') {
        swal('', 'Please select both date!', 'warning')
      } else {
        this.filterTable(this.startTime.time, this.startTime1.time, this.dateValue)
        this.filterApplied = true
      }
    }
  }
}
</script>

<style scoped>
.input-group--select.input-group--single-line.primary--text {
  padding: 0 !important;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 768px) {
  .mobile {
    float: left;
  }
}
.pointer {
  cursor: pointer;
}

.not-allowed {
  cursor: not-allowed;
}

.filter-branch-btn:hover {
  background-color: #2887e5 !important;
}

.animate-filter-branch-btn {
  animation: filter-branch-animation 0.4s 1;
}

@keyframes filter-branch-animation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preDatatableComponent.vue